import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'

import { selectActiveSource, selectSources } from 'redux/selectors/Sources'

export const useActiveSource = (activeSourceId: string) => {
  return useSelector((state: ApplicationState) =>
    selectActiveSource(state, activeSourceId)
  )
}

export const useSources = () => {
  return useSelector((state: ApplicationState) => selectSources(state))
}

/** In-flight mutations, for button loading states. */
export const useSourcesCreating = () => {
  return useSelector((state: ApplicationState) => state.SourceStore.creating)
}

export const useSourcesDeleting = () => {
  return useSelector((state: ApplicationState) => state.SourceStore.deleting)
}

export const useSourcesUpdating = () => {
  return useSelector((state: ApplicationState) => state.SourceStore.updating)
}

export const useSourcesCreatingSftp = () => {
  return useSelector(
    (state: ApplicationState) => state.SourceStore.creatingSFTP
  )
}
